import { Input, Checkbox, FormGroup, Box, H2 } from '@bigcommerce/big-design';
import CountriesDropdown from './Fields/CountriesDropdown';
import StatesDropdown from './Fields/StatesDropdown';

export function BillingAddressForm({ customer, setCustomer }) {
	const getCustomerValue = (name) => customer[name] ?? '';
	const getBillingAddressValue = (name) =>
		customer?.billing_address?.[name] ?? '';
	const showBillingAddressForm =
		getCustomerValue('billing_address_same_as_shipping') === false;
	const setCustomerInformation = (name, value) => {
		const customerCopy = { ...customer };
		customerCopy[name] = value;
		setCustomer({ ...customerCopy });
	};
	const setBillingAddressValue = (name, value) => {
		const addressData = { ...customer.billing_address };
		addressData[name] = value;
		setCustomerInformation('billing_address', addressData);
	};
	function toggleShowBillingAddress() {
		setCustomerInformation(
			'billing_address_same_as_shipping',
			!customer.billing_address_same_as_shipping,
		);
	}

	return (
		<Box borderRadius="normal" padding="medium">
			<H2>Billing Address</H2>
			<FormGroup>
				<div style={{ marginBottom: '2rem' }}>
					<Checkbox
						label="Billing Address Same as Shipping Address"
						checked={
							getCustomerValue(
								'billing_address_same_as_shipping',
							) !== false
						}
						onChange={() => toggleShowBillingAddress()}
					/>
				</div>
			</FormGroup>
			{showBillingAddressForm && (
				<FormGroup>
					<Input
						label="Street address"
						required
						type="text"
						value={getBillingAddressValue('address1')}
						onChange={({ target }) =>
							setBillingAddressValue('address1', target.value)
						}
					/>
					<Input
						label="City"
						required
						type="text"
						value={getBillingAddressValue('city')}
						onChange={({ target }) =>
							setBillingAddressValue('city', target.value)
						}
					/>
					<StatesDropdown
						getValue={getBillingAddressValue}
						setValue={setBillingAddressValue}
					/>
					<Input
						label="Zip/Postal Code"
						required
						type="text"
						value={getBillingAddressValue('postal_code')}
						onChange={({ target }) =>
							setBillingAddressValue('postal_code', target.value)
						}
					/>
					<CountriesDropdown
						getValue={getBillingAddressValue}
						setValue={setBillingAddressValue}
					/>
				</FormGroup>
			)}
		</Box>
	);
}
